import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../../styles/Breadcrumbs.css";

const Breadcrumbs = () => {
  const location = useLocation();

  // Split the path into segments
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav className="breadcrumbs">
      <ul>
        {/* Always show the "Dashboard" link */}
        <li>
          {pathnames.length === 0 ? ( // If there are no pathnames, we're on the dashboard
            <span>Dashboard</span>
          ) : (
            <Link to="/dashboard">Dashboard</Link>
          )}
        </li>

        {/* Dynamically render breadcrumbs for other paths */}
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          // Check if the breadcrumb is for an Edit page and redirect it to Dashboard
          const isEditPage = value.startsWith("edit");
          const redirectToDashboard = isEditPage && !isLast;

          return (
            <li key={to} className={isLast ? "breadcrumb-active" : ""}>
              <span className="separator">{' > '}</span> {/* Add the separator */}
              {isLast ? (
                <span>{value.replace("-", " ")}</span> // Highlight current page
              ) : redirectToDashboard ? (
                <Link to="/dashboard">{value.replace("-", " ")}</Link> // Redirect Edit pages to Dashboard
              ) : (
                <Link to={to}>{value.replace("-", " ")}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
